import * as React from "react";

const GavelIcon = ({ size = 20, color = "#fff", ...props }) => (
  <svg
    fill={color}
    viewBox="-4.211 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    className="cf-icon-svg"
    stroke={color}
    width={size}
    height={size}
    {...props}
  >
    <g strokeWidth={0} />
    <g strokeLinecap="round" strokeLinejoin="round" />
    <path d="M19.613 30.994a1.004 1.004 0 0 1-1 1H3.017a1.004 1.004 0 0 1-1-1v-1.817a1.004 1.004 0 0 1 1-1h15.596a1 1 0 0 1 1 1zm-5.825-5.446a1.16 1.16 0 0 1-.825-.343l-6.731-6.729a1.166 1.166 0 0 1 1.651-1.651l6.728 6.733a1.166 1.166 0 0 1-.825 1.992zm15.432 2.088-9.357-9.358 2.284-2.282-6.68-6.68-6.253 6.253 6.68 6.678 2.32-2.318 9.358 9.358a1.166 1.166 0 1 0 1.651-1.651zm-4.905-12.617a1.16 1.16 0 0 1-.823-.341l-6.734-6.731a1.166 1.166 0 1 1 1.651-1.651l6.728 6.731a1.166 1.166 0 0 1-.823 1.992z" />
  </svg>
);

export default GavelIcon;
  